import { MarketHoursEnum } from '@toggle/toggle';
import { TFunction } from 'i18next';

export const getMarketInsightTitle = (
  marketHours: MarketHoursEnum,
  t: TFunction
) => {
  switch (marketHours) {
    case 'pre_market':
      return {
        card: t('whatsNew:preMarket.cardTitle'),
        legacyCardTitle: t('whatsNew:preMarket.legacyCardTitle'),
        title: t('whatsNew:preMarket.title'),
      };
    case 'open_market':
      return {
        card: t('whatsNew:midday.cardTitle'),
        legacyCardTitle: t('whatsNew:midday.legacyCardTitle'),
        title: t('whatsNew:midday.title'),
      };
    default:
      return {
        card: t('whatsNew:closedMarket.cardTitle'),
        legacyCardTitle: t('whatsNew:closedMarket.legacyCardTitle'),
        title: t('whatsNew:closedMarket.title'),
      };
  }
};

export const getMarketInsightIcon = (marketHours: MarketHoursEnum) => {
  switch (marketHours) {
    case 'pre_market':
      return 'SunriseArrow';
    case 'open_market':
      return 'SunSolid';
    default:
      return 'SunsetArrow';
  }
};
